<!--
  File name: SecurityIncidentTable.vue
  Program Description:
    - This component renders the list of Annual Security Incident Report

  Includes:
    - CrudTableExpand: used to fetch the list of security incidents and renders it to
      a list table
-->
<template>
  <v-container flex>
    <CrudTableExpand
      ref="crudTable"
      v-bind="{
        meta,
        name: 'asir',
        mdTables
      }"
    />
  </v-container>
</template>

<script>
import { privilegeMixin } from 'session-plugin'
import table from '@/meta/mdTable/crudModules/securityIncident/table'
import mdTables from '@/meta/mdTable/crudModules/'

export default {
  name: 'AsirTable',
  mixins: [
    privilegeMixin
  ],
  data: () => ({}),
  computed: {
    meta () {
      return table
    },
    mdTables () {
      return mdTables
    }
  },
  methods: {
    async populateTable () {
      await this.$refs.crudTable.populateTable()
    }
  }
}
</script>
